module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-ford-24.c861f744.jpg";